import React from 'react';

export default function ReconnectBanner({ reconnectAttempt, connected }) {
  // Reconnect banner hidden — bad UX
  return null;

  /* Original banner commented out
  if (connected || reconnectAttempt === 0) return null;

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 10000,
      background: '#f59e0b', color: '#000', fontSize: 12, fontWeight: 600,
      padding: '6px 16px', textAlign: 'center',
      display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
    }}>
      <span style={{ animation: 'spin 1s linear infinite', display: 'inline-block' }}>⟳</span>
      Collaboration disconnected — reconnecting (attempt {reconnectAttempt})...
      <style>{`@keyframes spin { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }`}</style>
    </div>
  );
  */
}
